// Vendor
import { createReducer, on } from '@ngrx/store';
// Actions
import { setSavedHypotheticalId } from './saved-hypothetical-id.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
export const savedHypotheticalId = createReducer(null, on(setSavedHypotheticalId, (state, action) => {
    return action.savedHypotheticalId;
}), on(resetAllCustomPdfReportItems, () => {
    return null;
}));
